export default {
  reservations: 'Prenotazioni',
  activated: 'Attivata',
  deactivated: 'Disattivata',
  reservations_deactivated: 'Le prenotazioni sono disattivate.',
  tabs: {
    general: 'Generale',
    information: 'Informazioni',
  },
  sections: {
    notifications_confirmation: 'Notifiche e conferma',
    notifications_confirmation_description: 'Come prenotano gli ospiti e come ricevi le notifiche.',
    who_can_book: 'Chi può prenotare',
    who_can_book_description: 'Limiti di capienza del gruppo per le prenotazioni online.',
    when_how_bookings_work: 'Quando e come funzionano le prenotazioni',
    when_how_bookings_work_description:
      'Regole di orario, durata e capacità che determinano gli slot visibili agli ospiti.',
  },
  google: {
    label: 'Mostra prenotazioni su Google',
  },
  storefront: {
    label: 'Mostra prenotazioni sulla vetrina',
  },
  auto_confirm: {
    label: 'Conferma automaticamente le prenotazioni',
  },
  email: {
    label: 'Email per le prenotazioni in arrivo',
    add: 'Aggiungi email',
    placeholder: 'Inserisci email',
    required: "Aggiungi almeno un'email per ricevere le nuove prenotazioni.",
    invalid: 'Inserisci un indirizzo email valido.',
  },
  has_whatsapp_phone_number: {
    label: 'Invia notifiche tramite WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'Numero WhatsApp',
    add: 'Aggiungi numero di telefono',
  },
  party_size: {
    label: 'Dimensione del gruppo consentita per prenotazione',
    min_label: 'Min',
    max_label: 'Max',
    to: 'a',
    guests: 'ospiti',
    helper:
      'Dimensione minima e massima di una prenotazione. Un ospite può prenotare solo per un numero di persone in questo intervallo.',
    warning:
      'Google accetta solo prenotazioni da 2 a 16 ospiti. Le prenotazioni al di fuori di questo intervallo funzioneranno sulla vetrina, ma non appariranno su Google.',
    warning_min: 'Google consiglia un minimo di 2 ospiti per le prenotazioni.',
    warning_max: 'Google consiglia un massimo di 16 ospiti per le prenotazioni.',
    min_note: 'Google non offrirà prenotazioni per gruppi inferiori a {{count}}.',
  },
  time_slot: {
    label: 'Intervallo di prenotazione',
    helper: 'Gli ospiti possono prenotare a intervalli di questo numero di minuti.',
    extra: 'es. {{example}}',
  },
  reservation_gap: {
    label: 'Limite di prenotazione prima della chiusura',
    helper: "L'ultimo orario disponibile per iniziare una prenotazione, calcolato a ritroso dall'orario di chiusura.",
    helper_link: 'Visualizza gli orari delle prenotazioni',
    extra: 'es. chiudi alle 22:00, limite {{example}} min → ultimo inizio prenotabile: {{example}}',
  },
  reservation_notice_period: {
    label: 'Preavviso minimo',
    helper: "Il minimo anticipo con cui un ospite può prenotare rispetto all'orario di arrivo.",
    extra: 'es. prenota entro {{example}} per un arrivo alle 18:00',
  },
  opening_times: {
    label: 'Orari di apertura',
  },
  total_seats: {
    label: 'Capacità totale ospiti',
    helper:
      'Il numero massimo di ospiti (non tavoli) che possono essere seduti contemporaneamente. Conta i posti singoli — es. 5 tavoli da 4 = 20.',
  },
  capacity_explainer: {
    title: 'Come funziona la capacità',
    body: 'Questo è il numero di ospiti che puoi accogliere contemporaneamente. Ogni prenotazione occupa i posti per la sua durata, poi li libera per i prossimi ospiti. Il sistema garantisce spazio sufficiente per tutti i prenotati, evitando il sovraffollamento.',
    body_example:
      'Esempio: con 20 posti, puoi accettare una prenotazione di 12 ospiti alle 19:00 e una di 10 ospiti alle 21:00, perché i posti del primo gruppo si liberano prima che arrivi il secondo.',
  },
  note: {
    label: 'Nota',
  },
  grace_period: {
    label: 'Periodo di tolleranza',
    helper: "Per quanto tempo tenere il tavolo dopo l'orario di inizio della prenotazione.",
    tooltip:
      'Tempo extra aggiunto dopo la durata di una prenotazione prima che il tavolo venga offerto di nuovo (es. per pulire e riallestire il tavolo).',
    extra: 'es. occupato fino alle {{example}} per una prenotazione alle 18:00',
    placeholder: 'Inserisci il periodo di tolleranza',
  },
  information: {
    rules: {
      label: 'Il tuo tavolo sarà riservato per:',
      add: 'Aggiungi',
    },
  },
  reservation_duration: {
    label: 'Durata della prenotazione',
    helper: 'Per quanto tempo ogni tavolo è occupato per prenotazione.',
    tooltip:
      'Per quanto tempo un tavolo è occupato per ogni prenotazione. Viene usato per calcolare quando il tavolo torna disponibile per il prossimo ospite.',
    extra: 'es. 18:00 – {{example}}',
    minutes: '{{ count }} minuti',
    hour_one: '{{ count }} ora',
    hour_other: '{{ count }} ore',
  },
  buttons: {
    save: 'Salva',
    activate: 'Attiva',
    deactivate: 'Disattiva',
  },
  success_messages: {
    updated: 'Aggiornamento riuscito',
    saving_successful:
      'Aggiornamento riuscito. Tieni presente che Google potrebbe impiegare fino a 24 ore per riflettere le modifiche.',
  },
  error_messages: {
    invalid_phone_number: 'Numero di telefono non valido',
    saving_unsuccessful: 'Errore nel salvataggio. Riprova.',
    enter_correct_email: 'Inserisci un indirizzo email corretto.',
  },
};
